import React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import PublicIcon from "@mui/icons-material/Public";

//Custom Components
import TableButton from "./TableButton";

//Types
import { ITableActionButtonDetail } from "@/@types/ui/Table";


function TableButtonToggleJavno(props: ITableActionButtonDetail) {
  const { t } = useTranslation();

  return (
    <TableButton endIcon={<PublicIcon/>} allow="one" selection={[]} {...props}>
     {t('buttons.javno')}
    </TableButton>
  );
}

export default TableButtonToggleJavno;
